import e from "zod";
const i = /^(\*|(\d{2}:\d{2}-\d{2}:\d{2}))(?: (\*|(\d{1,2}-\d{1,2}))(?: (\*|(\d{1,2}-\d{1,2}))(?: (\*|([0-7]-[0-7])))?)?)?$/, o = (t, r = (a) => parseInt(a)) => {
  if (t && t !== "*")
    return t.split("-").map(r);
}, n = (t) => `${Math.floor(t).toString().padStart(2, "0")}:${Math.floor(
  t % 1 * 60
).toString().padStart(2, "0")}`, l = e.codec(e.string().regex(i), e.string(), {
  decode: (t) => t,
  encode: (t) => t.trim().replaceAll(/\s+/g, " ")
}), h = e.codec(
  e.string(),
  e.object({
    hour: e.tuple([e.number(), e.number()]).optional(),
    date: e.tuple([e.number(), e.number()]).optional(),
    month: e.tuple([e.number(), e.number()]).optional(),
    day: e.tuple([e.number(), e.number()]).optional()
  }),
  {
    decode: (t) => {
      const [r, a, m, u] = t.split(" ");
      return {
        hour: o(r, (s) => {
          const d = s.split(":");
          return parseInt(d[0]) + parseInt(d[1]) / 60;
        }),
        date: o(a),
        month: o(m),
        day: o(u)
      };
    },
    encode: (t) => `${t.hour ? `${n(t.hour[0])}-${n(t.hour[1])}` : "*"} ${t.date ? `${t.date[0]}-${t.date[1]}` : "*"} ${t.month ? `${t.month[0]}-${t.month[1]}` : "*"} ${t.day ? `${t.day[0]}-${t.day[1]}` : "*"}`
  }
);
export {
  h as C,
  l as a
};
//# sourceMappingURL=cron-CJR9-b_h.js.map
